export default __webpack_public_path__ + "static/media/EnterBKB.39d3f9ec.png";